var _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6, _circle3, _path7, _path8, _circle4, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepartmentBookActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 52,
    viewBox: "0 0 63 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7464 17.373V16.0548C36.7464 15.2798 36.4386 14.5366 35.8906 13.9886C35.3426 13.4407 34.5994 13.1328 33.8245 13.1328H29.4415C28.6666 13.1328 27.9233 13.4407 27.3754 13.9886C26.8274 14.5366 26.5195 15.2798 26.5195 16.0548V17.516",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6329 10.2111C33.2467 10.2111 34.5549 8.90293 34.5549 7.28916C34.5549 5.6754 33.2467 4.36719 31.6329 4.36719C30.0192 4.36719 28.7109 5.6754 28.7109 7.28916C28.7109 8.90293 30.0192 10.2111 31.6329 10.2111Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 10.0674,
    r: 9.06736,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9759 49.4939V48.3639C13.9759 47.6997 13.712 47.0626 13.2423 46.5929C12.7726 46.1232 12.1356 45.8594 11.4713 45.8594H7.71451C7.05026 45.8594 6.41322 46.1232 5.94353 46.5929C5.47383 47.0626 5.20996 47.6997 5.20996 48.3639V49.6164",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59342 43.3529C10.9766 43.3529 12.098 42.2315 12.098 40.8483C12.098 39.4651 10.9766 38.3438 9.59342 38.3438C8.21019 38.3438 7.08887 39.4651 7.08887 40.8483C7.08887 42.2315 8.21019 43.3529 9.59342 43.3529Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.47905,
    cy: 43.2291,
    r: 7.77202,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9974 49.4939V48.3639C35.9974 47.6997 35.7335 47.0626 35.2638 46.5929C34.7941 46.1232 34.1571 45.8594 33.4928 45.8594H29.736C29.0717 45.8594 28.4347 46.1232 27.965 46.5929C27.4953 47.0626 27.2314 47.6997 27.2314 48.3639V49.6164",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6139 43.3529C32.9972 43.3529 34.1185 42.2315 34.1185 40.8483C34.1185 39.4651 32.9972 38.3438 31.6139 38.3438C30.2307 38.3438 29.1094 39.4651 29.1094 40.8483C29.1094 42.2315 30.2307 43.3529 31.6139 43.3529Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4996,
    cy: 43.2291,
    r: 7.77202,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0179 49.4939V48.3639C58.0179 47.6997 57.754 47.0626 57.2843 46.5929C56.8146 46.1232 56.1776 45.8594 55.5133 45.8594H51.7565C51.0923 45.8594 50.4552 46.1232 49.9855 46.5929C49.5158 47.0626 49.252 47.6997 49.252 48.3639V49.6164",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6344 43.3529C55.0177 43.3529 56.139 42.2315 56.139 40.8483C56.139 39.4651 55.0177 38.3438 53.6344 38.3438C52.2512 38.3438 51.1299 39.4651 51.1299 40.8483C51.1299 42.2315 52.2512 43.3529 53.6344 43.3529Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.521,
    cy: 43.2291,
    r: 7.77202,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7796 33.1264V26.3906H8.96094V33.1264",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 21.7266C32.25 21.3123 31.9142 20.9766 31.5 20.9766C31.0858 20.9766 30.75 21.3123 30.75 21.7266H32.25ZM30.75 21.7266V32.0893H32.25V21.7266H30.75Z",
    fill: "#444444"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentBookActivity);
export default __webpack_public_path__ + "static/media/Department Book Activity.fe7936033874e590ee3d88c2545972d9.svg";
export { ForwardRef as ReactComponent };